import { CartStore } from '../store/cart-store';
import { getNavKey, NavigationItems, NavigationStore } from '../store/navigation-store';
import { CartService } from './cart-service';
import BurgerMenu from './menu-burger-service';
export default class MenuService {
    constructor() {
        this.onStateChange = (state, prevState) => {
            var _a, _b, _c, _d;
            const status = state.hasActive();
            (_a = this.backdrop) === null || _a === void 0 ? void 0 : _a.classList.toggle('active', status);
            (_b = this.header) === null || _b === void 0 ? void 0 : _b.classList.toggle('active', status);
            document.body.classList.toggle('no-scroll', status);
            const activeName = this.getActiveName(state);
            const prevActiveName = this.getActiveName(prevState);
            if (activeName) {
                (_c = this.backdrop) === null || _c === void 0 ? void 0 : _c.classList.add(`menu-${activeName.toLowerCase()}`);
            }
            if (prevActiveName) {
                (_d = this.backdrop) === null || _d === void 0 ? void 0 : _d.classList.remove(`menu-${prevActiveName.toLowerCase()}`);
            }
            if (activeName === NavigationItems.CART && prevActiveName !== NavigationItems.CART) {
                console.log('Cart menu opened');
                if (!CartStore.getState().skipNextCartTrack) {
                    console.log('Tracking cart view event');
                    CartService.trackViewCartEvent();
                }
            }
        };
        this.backdrop = document.querySelector('.backdrop');
        this.header = document.querySelector('.site-header');
    }
    init() {
        this.burgerMenu = new BurgerMenu('.header-burger', ['.nav-btn-burger', '.header-burger-close-btn'], NavigationItems.BURGER);
        this.cartMenu = new BurgerMenu('.header-cart', ['.nav-btn-cart', '.header-cart-close-btn'], NavigationItems.CART);
        this.burgerMenu.init();
        this.cartMenu.init();
        this.onBackdropClick();
        NavigationStore.subscribe(this.onStateChange);
    }
    getActiveName(state) {
        return Object.values(NavigationItems).find((nav) => state[getNavKey(nav)]);
    }
    onBackdropClick() {
        var _a;
        (_a = this.backdrop) === null || _a === void 0 ? void 0 : _a.addEventListener('pointerdown', () => {
            var _a;
            if ((_a = this.backdrop) === null || _a === void 0 ? void 0 : _a.classList.contains('cookies')) {
                return;
            }
            NavigationStore.getState().closeAll();
        });
    }
}
